Drupal.behaviors.home_facts = {
  attach: function (context, settings) {
   'use strict';

    jQuery(function() {

      jQuery('.home-facts', context).each(function(index) {
        let gallery = jQuery(this);

        gallery.slick({
          slidesPerRow: 1,
          slidesToScroll: 1,
          rows: 1,
          arrows: true,
          infinite: false,
          mobileFirst: true,
          responsive: [
            {
              breakpoint: 550,
              settings: {
                slidesPerRow: 2,
                rows: 2,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesPerRow: 3,
                rows: 2,
              }
            },
            {
              breakpoint: 1000,
              settings: {
                slidesPerRow: 4,
                rows: 2,
              }
            },
          ]
        });
      });

    });
  }
}
